import { HttpClient } from '../HttpClient';
/**
 * * Get List of Attendance Logs via SearchCriteria
 */
export const GetAttendanceLogsSearchCriteria = async ({ Id }) => {
  try {
    const { data } = await HttpClient.get(`/api/attendancelogs/searchCriteria`, {
      params: {
        Id,
      },
    });
    return await Promise.resolve(data);
  } catch (err) {
    return Promise.reject(err);
  }
};
